import styled from 'styled-components';

type StyleProps = {
  $isProductPage?: boolean;
  $fullScreen?: boolean;
  $height?: number;
};

const Video = styled.video<StyleProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ $fullScreen, $isProductPage, $height }) =>
    $fullScreen
      ? '100%'
      : $isProductPage
        ? '80vh'
        : $height
          ? `${$height}vh`
          : '56vh'};
  object-fit: cover;
  object-position: center;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    height: 100vh;
  }
`;

const Overlay = styled.div<{
  $opacity: number;
  $overlayType: 'gradient' | 'overlay';
  $alignBottom?: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  background: ${({ $overlayType, $opacity, $alignBottom }) =>
    $overlayType === 'gradient'
      ? `linear-gradient(
        ${!$alignBottom ? 'to bottom' : 'to top'},
        rgba(0, 0, 0, ${$opacity / 100}) 0%,
        rgba(0, 0, 0, ${($opacity - 25) / 100}) 45%,
        rgba(0, 0, 0, 0) 100%
      )`
      : `rgba(0, 0, 0, ${$opacity / 100})`};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    background: ${({ $overlayType, $opacity, $alignBottom }) =>
      $overlayType === 'gradient'
        ? `linear-gradient(
        ${!$alignBottom ? 'to bottom' : 'to top'},
        rgba(0, 0, 0, ${$opacity / 100}) 0%,
        rgba(0, 0, 0, ${($opacity - 25) / 100}) 30%,
        rgba(0, 0, 0, 0) 100%
      )`
        : `rgba(0, 0, 0, ${$opacity / 100})`};
  }
`;

const VideoWrapper = styled.div<StyleProps>`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

const VimeoWrapper = styled.div<StyleProps>`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  iframe {
    position: absolute;
    inset: 0;
    width: auto;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    aspect-ratio: 16 / 8;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
      min-width: 100vw;
      height: auto;
      overflow: hidden;
      min-height: 100vh;
      top: 50%;
      transform: translate(-50%, -50%);
      aspect-ratio: 16 / 9;
    }
  }
`;

const PosterImage = styled.img`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: cover;
  z-index: -1;
`;

const S = {
  Video,
  Overlay,
  VimeoWrapper,
  VideoWrapper,
  PosterImage,
};

export default S;
